<template>
    <component
        class="flex items-center justify-center px-8 py-4 transition-colors rounded-lg bg-brand-blue"
        :is="element"
        :href="href"
        v-bind="$attrs"
        @click="$emit('click', $event)"
    >
        <slot></slot>
    </component>
</template>

<script>
export default {
    emits: ['click'],
    inheritAttrs: false,
    props: {
        href: {
            type: String,
            default: null,
        }
    },
    computed: {
        element: function () {
            return this.href ? 'a' : 'button';
        }
    }
}
</script>
